// Query with lowestPrice for classic rate plan details
// Root attribute: UseClassicRatePlanDetails = true
import { gql } from "@apollo/client";

export const GET_AVAILABLE_RATE_GROUPS_WITH_LOWEST_PRICE = gql`
  query getRateGroupsClassic(
    $input: AvailableRateGroupsInput!
    $from: Date!
    $until: Date!
    $filter: [RateGroupFilter!]
  ) {
    availableRateGroups(input: $input, filter: $filter) {
      id
      name
      code
      accommodationType {
        id
        name
        code
      }
      description
      isArchived
      isParcel
      guestCapacity
      guestAdditionalCapacity
      maxAvailability(from: $from, until: $until)
      translations {
        name
        description
        language
      }
      images {
        id
        url
        galleryPositionIndex
        isPrimary
      }
      ratePlans {
        id
        name
        description
        occupancy
        isArchived
        rateSellMode
        isAvailable(from: $from, until: $until)
        translations {
          name
          description
          language
        }
        lowestPrice(from: $from, until: $until)
        defaultPriceBreakdown(from: $from, until: $until) {
          discountPercentage
          withDiscount
          withoutDiscount
        }
        parentPerPersonRatePlan {
          id
        }
        cancelationPolicy {
          id
          name
          description
          translations {
            name
            description
            language
          }
        }
      }
      amenities {
        description
        value
        translations {
          description
          language
        }
      }
    }
  }
`;
